/* eslint-disable camelcase */
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const useTracking = () => {
  const TRACKING_EVENTS = {
    ALERT_DELETED_VIEWED: 'Delete Alert Viewed',
    ALERT_DELETED: 'Alert Deleted',
    ALERT_EDIT_VIEWED: 'Edit Alert Viewed',
    ALERT_EDITED_ERROR: 'Alert Modified Error',
    ALERT_EDITED_SUCCESS: 'Alert Modified',
    CHANGE_FREQUENCY_DONE: 'Alert Frequency Modified',
    CHANGE_FREQUENCY_VIEWED: 'Edit Alert Frequency Viewed',
    EMAIL_NOTIFICATIONS_ALLOWED: 'Email Notifications Allowed',
    EMAIL_NOTIFICATIONS_DISMISSED: 'Email Notifications Dismissed',
    MOBILE_PUSH_NOTIFICATIONS_ALLOWED: 'Mobile Push Notifications Allowed',
    MOBILE_PUSH_NOTIFICATIONS_DISMISSED: 'Mobile Push Notifications Dismissed'
  }

  const formNameUpdateAlertTracking = 'modifica tu alerta'

  const viewedAlertTrackingOrigins = {
    FROM_DELETE_MODAL: 'delete button',
    FROM_EDIT_BUTTON: 'edit button'
  }

  const changeFrequencyTrackingInformation = {
    DAILY: 'diarias',
    REAL_TIME: 'inmediatas',
    ERROR: 'error'
  }

  const {track} = useAnalyticsTrack()

  const alertDeleted = () => {
    track({
      event: TRACKING_EVENTS.ALERT_DELETED
    })
  }

  const alertDeletedViewed = () => {
    track({
      event: TRACKING_EVENTS.ALERT_DELETED_VIEWED
    })
  }

  const alertEditedError = ({error}) => {
    track({
      event: TRACKING_EVENTS.ALERT_EDITED_ERROR,
      ...(error.field && {
        data: {form_fields: error.field}
      })
    })
  }

  const alertEditedSuccess = ({filtersChanged}) => {
    track({
      event: TRACKING_EVENTS.ALERT_EDITED_SUCCESS,
      data: {
        form_name: formNameUpdateAlertTracking,
        form_fields: filtersChanged?.join(':')
      }
    })
  }

  const alertEditViewedFromDeleteButton = () => {
    track({
      event: TRACKING_EVENTS.ALERT_EDIT_VIEWED,
      data: {hit_origin: viewedAlertTrackingOrigins.FROM_DELETE_MODAL}
    })
  }

  const alertEditViewedFromUpdateButton = () => {
    track({
      event: TRACKING_EVENTS.ALERT_EDIT_VIEWED,
      data: {hit_origin: viewedAlertTrackingOrigins.FROM_EDIT_BUTTON}
    })
  }

  const changeFrequencyNotificationDone = ({frequencyData, changeFrequencyError, previousFrequency}) => {
    const hit_information = changeFrequencyError
      ? changeFrequencyTrackingInformation.ERROR
      : changeFrequencyTrackingInformation[frequencyData.value]

    track({
      event: TRACKING_EVENTS.CHANGE_FREQUENCY_DONE,
      data: {
        hit_information,
        ...(!changeFrequencyError && {
          hit_origin: changeFrequencyTrackingInformation[previousFrequency]
        })
      }
    })
  }

  const changeFrequencyViewedFromDeleteButton = () => {
    track({
      event: TRACKING_EVENTS.CHANGE_FREQUENCY_VIEWED,
      data: {hit_origin: viewedAlertTrackingOrigins.FROM_DELETE_MODAL}
    })
  }

  const changeFrequencyViewedFromEditButton = () => {
    track({
      event: TRACKING_EVENTS.CHANGE_FREQUENCY_VIEWED,
      data: {hit_origin: viewedAlertTrackingOrigins.FROM_EDIT_BUTTON}
    })
  }

  const emailNotificationsAllowed = () => {
    track({
      event: TRACKING_EVENTS.EMAIL_NOTIFICATIONS_ALLOWED
    })
  }

  const emailNotificationsDismissed = () => {
    track({
      event: TRACKING_EVENTS.EMAIL_NOTIFICATIONS_DISMISSED
    })
  }

  const pushNotificationsAllowed = () => {
    track({
      event: TRACKING_EVENTS.MOBILE_PUSH_NOTIFICATIONS_ALLOWED
    })
  }

  const pushNotificationsDismissed = () => {
    track({
      event: TRACKING_EVENTS.MOBILE_PUSH_NOTIFICATIONS_DISMISSED
    })
  }

  return {
    alertDeleted,
    alertDeletedViewed,
    alertEditedError,
    alertEditedSuccess,
    alertEditViewedFromDeleteButton,
    alertEditViewedFromUpdateButton,
    changeFrequencyNotificationDone,
    changeFrequencyViewedFromDeleteButton,
    changeFrequencyViewedFromEditButton,
    emailNotificationsAllowed,
    emailNotificationsDismissed,
    pushNotificationsAllowed,
    pushNotificationsDismissed
  }
}

export {useTracking}
